const ResponsesStore = {
  namespaced: true,
  state: {
    successMsg: '',
    general: '',
    detailed: {},
  },
  mutations: {
    SET_GENERAL_ERROR(state, errorMessage) {
      state.general = errorMessage;
    },
    SET_DETAILED_ERRORS(state, { context, errorMessages }) {
      state.detailed[context] = errorMessages;
    },
    CLEAR_ERRORS(state, context) {
      state.general = '';
      state.detailed[context] = {};
    },
    SET_SUCCESS_MESSAGE(state, successMessage) {
      state.successMsg = successMessage;
    },
    CLEAR_SUCCESS_MESSAGE(state) {
      state.successMsg = '';
    },
  },
  actions: {
    setErrors({ commit }, { context, status, data }) {
      if (status === 500) {
        commit('SET_GENERAL_ERROR', 'Ops, ocorreu um erro no servidor. Tente novamente mais tarde.');
      } else if (data.error_messages) {
        const baseErrorKeys = _.compact(_.flatten(Object.keys(data.error_messages).map((key) => (key.match(/base/) ? key : null))));
        if (baseErrorKeys.length > 0) {
          commit('SET_GENERAL_ERROR', baseErrorKeys.map((key) => data.error_messages[key]).join('. '));
        }
        commit('SET_DETAILED_ERRORS', { [context]: data.error_messages });
      } else {
        commit('SET_GENERAL_ERROR', data.error);
      }
    },
    clearErrors({ commit }, context) {
      commit('CLEAR_ERRORS', context);
    },
    setSuccess({ commit }, data) {
      commit('SET_SUCCESS_MESSAGE', data);
    },
    clearSuccess({ commit }) {
      commit('CLEAR_SUCCESS_MESSAGE');
    },
  },
};

export default ResponsesStore;
